<template>
  <t-vdxb-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form v-if="show_form" class="t-vdxb-application-invite-user-form__form" @submit.prevent="handleSubmitForm">
      <a-vdxb-text>
        請求書送付先を記入してください<br />
        お申し込み者情報を初期表示しています
      </a-vdxb-text>

      <div class="t-vdxb-application-invite-user-form__fields">
        <m-form-input label="郵便番号" type2="必須">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-vdxb-text-field
              id="invoicePostCode"
              v-model="formData.invoicePostCode"
              type="text"
              placeholder="1234567"
              maxlength="7"
              required
              :error="getFieldError('invoicePostCode')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoicePostCode.isError"
              v-html="backendErrorDict.invoicePostCode.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>ハイフンは入れずにご入力ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="都道府県名" type2="必須">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-vdxb-select-field
              v-if="isLoaded"
              id="-invoiceAddress1"
              v-model="formData.invoiceAddress1"
              placeholder="都道府県を選択してください"
              :options="prefectures"
              :error="getFieldError('invoiceAddress1')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoiceAddress1.isError"
              v-html="backendErrorDict.invoiceAddress1.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="市区町村" type2="必須">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-vdxb-text-field
              id="invoiceAddress2"
              v-model="formData.invoiceAddress2"
              type="text"
              placeholder="千代田区"
              maxlength="20"
              :error="getFieldError('invoiceAddress2')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoiceAddress2.isError"
              v-html="backendErrorDict.invoiceAddress2.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="字丁目番地など" type2="必須">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-vdxb-text-field
              id="invoiceAddress3"
              v-model="formData.invoiceAddress3"
              type="text"
              placeholder="大手町２－３－１"
              maxlength="20"
              :error="getFieldError('invoiceAddress3')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoiceAddress3.isError"
              v-html="backendErrorDict.invoiceAddress3.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="住所建物など" type="任意">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-vdxb-text-field
              id="invoiceAddress4"
              v-model="formData.invoiceAddress4"
              type="text"
              placeholder="大手町プレイスウエストタワー"
              maxlength="20"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoiceAddress4.isError"
              v-html="backendErrorDict.invoiceAddress4.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>建物名・部屋番号などがある場合は必ずご記入ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="送付先名" type2="必須">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-vdxb-text-field
              id="invoiceName"
              v-model="formData.invoiceName"
              type="text"
              placeholder="NTTコミュニケーションズ株式会社経理部"
              maxlength="20"
              required
              :error="getFieldError('invoiceName')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoiceName.isError"
              v-html="backendErrorDict.invoiceName.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="送付先名カナ" type2="必須">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-text-field
              id="invoiceKanaName"
              v-model="formData.invoiceKanaName"
              type="text"
              placeholder="エヌティティコミュニケーションズカブシキガイシャケイリブ"
              maxlength="35"
              :error="getFieldError('invoiceKanaName')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoiceKanaName.isError"
              v-html="backendErrorDict.invoiceKanaName.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="電話番号" type2="必須">
          <div class="t-vdxb-application-invite-user-invoice__includeerror">
            <a-vdxb-text-field
              id="invoicePhoneNumber"
              v-model="formData.invoicePhoneNumber"
              type="tel"
              placeholder="09012345678"
              maxlength="11"
              :error="getFieldError('invoicePhoneNumber')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.invoicePhoneNumber.isError"
              v-html="backendErrorDict.invoicePhoneNumber.msg"
              class="t-vdxb-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>ハイフンは入れずにご入力ください。</li>
          </template>
        </m-form-input>
      </div>
      <div class="t-vdxb-application-invite-user-form__buttons">
        <m-button-container>
          <!--
          <a-vdxb-button variant="block" submit="submit" color="primary" :disabled="hasError">次へ</a-button>
          -->
          <a-vdxb-button id="next" variant="block" submit="submit" color="primary" :disabled="!agree"
            >次へ</a-vdxb-button
          >
          <a-vdxb-button id="back" color="primary" @click="handleCancelClick">戻る</a-vdxb-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-vdxb-modal
        v-model:visible="resultModalVisible"
        class="o-vdxb-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-vdxb-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-vdxb-text>
        <template #footer>
          <a-vdxb-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-vdxb-modal>
    </teleport>
  </t-vdxb-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TVdxbDefaultEntrySidebar from '@/components/templates/vdxb-default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
import AVdxbTextField from '@/components/atoms/vdxb-text-field';
import AVdxbButton from '@/components/atoms/vdxb-button';
import MButtonContainer from '@/components/molecules/button-container';
import { cloneDeep } from 'lodash';
import OVdxbModal from '@/components/organisms/vdxb-modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { PREFECTURES } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2456

import { utils } from '@/common/utils.js';

export default {
  name: 't-vdxb-application-invite-user-invoice',
  components: {
    TVdxbDefaultEntrySidebar,
    MFormInput,
    AVdxbTextField,
    AVdxbButton,
    MButtonContainer,
    OVdxbModal,
  },
  mixins: [messageContent, customRequest, customValidate], // #2456
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // errorList: {
    //   type: Object,
    //   default: null,
    // },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      // formData: {
      //   name: '',
      //   componay_name: '',
      //   phone_number: '',
      //   postal_code: '',
      //   street_address: '',
      //   email: '',
      //   password: '',
      //   password_confirm: '',
      // },
      formData: {
        invoicePostCode: '',
        invoiceAddress1: '',
        invoiceAddress2: '',
        invoiceAddress3: '',
        invoiceAddress4: '',
        invoiceName: '',
        invoicePhoneNumber: '',
      },
      sidebarInfo: {
        sidebarList: [
          { label: '契約情報の入力' },
          { label: '本人確認書類' },
          { label: '請求書送付先' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 3,
        heading: '請求書送付先',
        subHeading: 'Step 3',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      tmpCompanyID: '',
      tmpDate: '',
      agree: false,
      businessType: '',
      errorList: [],
      prefectures: [],
      isLoaded: false,
      show_form: false,
      tmpUUID: '',
      tmpYMD: '',
      // #2456
      spCharCheckListInvoice: [
        {
          name: '郵便番号',
          fieldName: 'invoicePostCode',
        },
        {
          name: '都道府県名',
          fieldName: 'invoiceAddress1',
        },
        {
          name: '市区町村',
          fieldName: 'invoiceAddress2',
        },
        {
          name: '字丁目番地など',
          fieldName: 'invoiceAddress3',
        },
        {
          name: '住所建物など',
          fieldName: 'invoiceAddress4',
        },
        {
          name: '送付先名',
          fieldName: 'invoiceName',
        },
        {
          name: '送付先名カナ',
          fieldName: 'invoiceKanaName',
        },
        {
          name: '電話番号',
          fieldName: 'invoicePhoneNumber',
        },
      ],
      backendErrorDict: {
        invoicePostCode: {
          isError: false,
          msg: '',
        },
        invoiceAddress1: {
          isError: false,
          msg: '',
        },
        invoiceAddress2: {
          isError: false,
          msg: '',
        },
        invoiceAddress3: {
          isError: false,
          msg: '',
        },
        invoiceAddress4: {
          isError: false,
          msg: '',
        },
        invoiceName: {
          isError: false,
          msg: '',
        },
        invoiceKanaName: {
          isError: false,
          msg: '',
        },
        invoicePhoneNumber: {
          isError: false,
          msg: '',
        },
      },
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-application-invite-user-form');
      return `${baseClassName} ${this.class}`.trim();
    },
    hasError() {
      let isValid = true;
      if (this.errorList) {
        isValid = !Object.keys(this.errorList).length > 0;
      }
      return isValid;
    },
  },
  async mounted() {
    document.title = '請求書送付先 | COTOHA Voice DX Basic';

    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: '/vdxbsignup' });
      return; // #2314
    }

    try {
      this.prefectures = PREFECTURES;
      this.tmpCompanyID = this.tmpUUID;
      this.tmpDate = this.tmpYMD;
      if (!this.tmpCompanyID || !this.tmpDate) {
        throw new Error('Invalid data.');
      }

      const result = await this.getHistoryDoc(this.tmpCompanyID, this.tmpDate);

      this.formData.invoicePostCode = result.invoicePostCode ? result.invoicePostCode : result.adminPostCode;
      this.formData.invoiceAddress1 = result.invoiceAddress1 ? result.invoiceAddress1 : result.adminAddress1;
      this.formData.invoiceAddress2 = result.invoiceAddress2 ? result.invoiceAddress2 : result.adminAddress2;
      this.formData.invoiceAddress3 = result.invoiceAddress3 ? result.invoiceAddress3 : result.adminAddress3;
      if (result.invoiceAddress3 !== '') {
        this.formData.invoiceAddress4 = result.invoiceAddress4 ? result.invoiceAddress4 : '';
      } else {
        this.formData.invoiceAddress4 = result.invoiceAddress4 ? result.invoiceAddress4 : result.adminAddress4;
      }
      if (typeof result.invoiceKanaName !== 'undefined' && result.invoiceKanaName !== '') {
        this.formData.invoiceKanaName = result.invoiceKanaName;
      } else {
        this.formData.invoiceKanaName = result.adminKanaName.replace('_', '').substr(0, 35);
      }

      if (result.invoiceName !== '') {
        this.formData.invoiceName = result.invoiceName;
      } else {
        this.formData.invoiceName = result.adminName.replace('_', '').substr(0, 20);
      }

      if (result.invoicePostCode !== '') {
        this.formData.invoicePhoneNumber = result.invoicePhoneNumber ? result.invoicePhoneNumber : '';
      } else {
        this.formData.invoicePhoneNumber = result.invoicePhoneNumber
          ? result.invoicePhoneNumber
          : result.adminPhoneNumber;
      }

      if (result.businessType !== 'individual' && result.businessType !== 'company') {
        throw new Error('businessType: Invalid data.');
      }
      this.businessType = result.businessType;
      this.isLoaded = true;

      if (result.businessType === 'company') {
        this.sidebarInfo.sidebarList[0] = { label: '契約情報の入力' };
        this.sidebarInfo.sidebarList[1] = { label: '本人確認書類' };
        this.sidebarInfo.sidebarList[2] = { label: '契約情報の入力(法人)' };
        this.sidebarInfo.sidebarList[3] = { label: '法人の確認書類' };
        this.sidebarInfo.sidebarList[4] = { label: '請求書送付先' };
        this.sidebarInfo.sidebarList[5] = { label: 'お申し込み内容確認' };
        this.sidebarInfo.sidebarCurrent = 5;
        this.sidebarInfo.subHeading = 'Step 5';
        this.sidebarInfo.heading = '請求書送付先';
      }
      // #3249
      if (result.businessType === 'company') {
        utils.setMetaDescription2(this.$route);
      } else {
        utils.setMetaDescription(this.$route);
      }
    } catch (error) {
      console.log(error);
      this.showErrorModal(messageContent.requireTry('情報取得'));
    }

    this.show_form = true;
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSubmitForm(e) {
      // #2456 特殊記号チェックを追加
      for (const item of this.spCharCheckListInvoice) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.formData[item.fieldName] })) {
          const errMsg = messageContent.requireNotSpecialCharacter(item.name);
          this.setBackendErrorMsg([{ param: item.fieldName, msg: errMsg }]);
          this.showErrorModal(errMsg);
          return;
        }
      }

      e.preventDefault();
      /*
      const payload = cloneDeep(this.formData);
      this.handleFormSubmit(payload);
      */

      const formDataTmp = {
        tmpCompanyID: this.tmpCompanyID,
        date: this.tmpDate,
        data: this.formData,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      fetch('/signup/updateinvoicehistorydoc', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              if (Array.isArray(e.errors)) {
                this.setBackendErrorMsg(e.errors);
                const errMsg = e.errors.map(e => e.msg).join('<br />');
                this.showErrorModal(errMsg);
                return {};
              } else if (e.msg) {
                this.showErrorModal(e.msg);
                return {};
              } else {
                throw new Error('/signup/updateinvoicehistorydoc response was not ok.');
              }
            }

            this.$router.push({ name: 'VdxbSignupConfirm' });
            return {};
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('請求書送付先の登録'));
        });
    },
    // エラーリストを更新（引数無しで呼び出すとエラーを全て空にする）
    setBackendErrorMsg(errors) {
      Object.keys(this.backendErrorDict).forEach(fieldName => {
        this.backendErrorDict[fieldName].isError = false;
        this.backendErrorDict[fieldName].msg = '';
      });
      if (!Array.isArray(errors)) return;
      for (const error of errors) {
        if (typeof error.param !== 'string') continue;
        const fieldName = error.param.split('.').slice(-1)[0];
        const target = this.backendErrorDict[fieldName];
        target.isError = true;
        target.msg += target.msg === '' ? error.msg : `<br />${error.msg}`;
      }
    },
    getFieldError(key) {
      this.agree = false;
      if (
        this.formData.invoicePostCode &&
        this.formData.invoiceAddress1 &&
        this.formData.invoiceAddress2 &&
        this.formData.invoiceAddress3 &&
        this.formData.invoiceKanaName &&
        this.formData.invoiceName &&
        this.formData.invoicePhoneNumber
      ) {
        this.agree = true;
      }

      if (this.errorList && this.errorList[key]) {
        return this.errorList[key];
      }
      return null;
    },
    handleCancelClick() {
      if (this.businessType === 'individual') {
        this.$router.push({ name: 'VdxbSignupUpload' });
      } else if (this.businessType === 'company') {
        this.$router.push({ name: 'VdxbSignupUploadH' });
      }
    },
    getHistoryDoc(tmpCompanyID, date) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/gethistorydoc', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/gethistorydoc response was not ok.');
            }
            return e.result;
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('法人情報の登録'));
        });
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
  },
};
</script>
